import React, { useEffect, useState } from "react"
import { connect, ConnectedProps } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import { Button, Input, InputGroup, InputGroupText } from "reactstrap"
import { MyIcon } from "src/core/components"
import { showToastError } from "src/core/helpers/ui"
import { PATH } from "src/helpers/paths"
import ApiGeneric from "src/services/apiGeneric"
import { ErrorMessage, Form, Title } from "./Login.styles"
import { login, loginSuccessWithResponse } from "./Login.thunks"
import Container from "./LoginContainer"
import { HConfig } from "src/core/helpers"
import i18next from "i18next"
import useForceUpdate from "src/core/hook/useForceUpdate"
import HValid from "src/helpers/Valid"
import { updateFetchResetValidToken } from "src/App/App.actions"

const mapStateToProps = state => ({
  loading: state.loading,
  isAuthenticated: state.app.isAuthenticated,
  fetchResetValidToken: state.app.fetchResetValidToken,
})

const mapDispatchToProps = {
  login,
  loginSuccessWithResponse,
  updateFetchResetValidToken,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

interface Props extends ConnectedProps<typeof connector> {}

const Login = (props: Props) => {
  const history = useHistory()
  const params = useParams() || {}
  const pTokenKey = (params as any).tokenkey || ""
  const [tokenKey, setTokenkey] = useState(pTokenKey)
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [cfpassword, setCFPassword] = useState("")
  const [showCFPassword, setShowCFPassword] = useState(false)
  const [error, setError] = useState("")
  const [loadingRequestReset, setLoadingRequestReset] = useState(false)
  const valids: any = React.useRef({})
  const fetchResetValidToken = props.fetchResetValidToken
  const forceUpdate = useForceUpdate()
  useEffect(() => {
    HConfig.changeTitle(
      i18next.t("Reset Password"),
      i18next.t("Reset Password")
    )
  }, [])
  const requestValidToken = (data = {}) => {
    props.updateFetchResetValidToken({
      loading: true,
    })
    // setLoadingRequestValid(true)
    ApiGeneric({
      method: "POST",
      url: "Account/ValidateToken",
      data: data,
    })
      .then(r => {
        // setLoadingRequestValid(false)
        if (r && r.Data && r.Data.IsValid) {
          // setValidToken(true)
          props.updateFetchResetValidToken({
            loading: false,
            error: null,
            isValid: true,
          })
        } else if (r && r.Data && r.Data.Msg) {
          showToastError(r.Data.Msg)
          props.updateFetchResetValidToken({
            loading: false,
            error: r.Data.Msg,
            isValid: false,
          })
        }
      })
      .catch(err => {
        props.updateFetchResetValidToken({
          loading: false,
          error: err,
          isValid: false,
        })
      })
  }
  const requestReset = (data = {}) => {
    setLoadingRequestReset(true)
    ApiGeneric({
      method: "POST",
      url: "Account/ResetPassword",
      data: data,
    })
      .then(r => {
        setLoadingRequestReset(false)
        history.push(PATH.HOME)
      })
      .catch(err => {
        setLoadingRequestReset(false)
        if (err && err.msg) {
          setError(err.msg)
        }
      })
  }

  const submitValidToken = async (
    event: React.FormEvent<HTMLFormElement> | null
  ) => {
    event && event.preventDefault()
    if (!fetchResetValidToken.loading) {
      const payload = {
        PasswordKey: tokenKey,
      }
      requestValidToken(payload)
    }
  }
  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!loadingRequestReset) {
      valids.current["password"] = HValid.checkValidField(
        mapFieldCheckVaid["password"],
        password
      )
      let _valid = true
      for (let f of Object.keys(valids.current)) {
        if (valids.current[f] !== true) {
          _valid = false
        }
      }
      if (_valid === false) {
        forceUpdate()
        return
      }

      const payload = {
        PasswordKey: tokenKey,
        Password: password,
        ConfirmPassword: cfpassword,
      }
      requestReset(payload)
    }
  }

  React.useEffect(() => {
    if (!fetchResetValidToken.error) {
      submitValidToken(null)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const mapFieldCheckVaid = {
    password: "User_Password",
  }
  const checkValid = (field, value) => {
    if (field && mapFieldCheckVaid[field]) {
      valids.current[field] = HValid.checkValidField(
        mapFieldCheckVaid[field],
        value
      )
      forceUpdate()
    }
  }
  console.warn("render :", params, tokenKey, valids)
  if (!fetchResetValidToken.isValid) {
    return (
      <Container>
        <Form
          className="p-5 rounded-sm shadow text-center"
          onSubmit={submitValidToken}
          autoComplete="off"
        >
          <Title
            style={{ marginTop: "0px", fontSize: "1.75rem" }}
            className="text-left text-ms-black fw-600 mb-4"
          >
            <div style={{ textTransform: "capitalize" }}>
              {i18next.t("Reset Password")}
            </div>
          </Title>
          <InputGroup style={{ marginBottom: "1rem" }}>
            <InputGroupText>
              <i className="fa fa-key" />
              {/* <MyIcon data="type:HiOutlineKey" /> */}
            </InputGroupText>
            <Input
              type={"text"}
              placeholder={i18next.t("Token key")}
              autoComplete="on"
              value={tokenKey}
              onChange={ev => {
                setTokenkey(ev.currentTarget.value)
              }}
            />
          </InputGroup>
          {error && (
            <ErrorMessage className="mb-3 text-danger text-xl-center">
              {error}
            </ErrorMessage>
          )}
          <Button type="submit" color="primary" style={{ width: "100%" }}>
            {i18next.t("Valid Token")}
          </Button>
        </Form>
      </Container>
    )
  }
  return (
    <Container>
      <Form className="p-5 rounded-sm shadow text-center" onSubmit={submit}>
        <Title
          style={{ marginTop: "0px", fontSize: "1.75rem" }}
          className="text-left text-ms-black fw-600 mb-4"
        >
          <div style={{ textTransform: "capitalize" }}>
            {i18next.t("Reset Password")}
          </div>
        </Title>
        <div style={{ marginBottom: "1rem" }}>
          <InputGroup>
            <InputGroupText>
              <i className="fa fa-key" />
            </InputGroupText>
            <Input
              type={showPassword === true ? "text" : "password"}
              placeholder={i18next.t("Password")}
              autoComplete="on"
              value={password}
              onChange={ev => {
                setPassword(ev.currentTarget.value)
              }}
              onBlur={ev => {
                checkValid("password", ev.currentTarget.value)
              }}
            />
            <InputGroupText
              onClick={() => {
                setShowPassword(!showPassword)
              }}
            >
              <MyIcon
                data={
                  showPassword ? "type:HiOutlineEye" : "type:HiOutlineEyeOff"
                }
              />
            </InputGroupText>
          </InputGroup>
          {valids.current && typeof valids.current.password === "string" && (
            <div
              className="a-invalid-msg"
              style={{ color: "rgb(255, 78, 84)" }}
            >
              {valids.current.password}
            </div>
          )}
        </div>
        <InputGroup style={{ marginBottom: "1rem" }}>
          <InputGroupText>
            <i className="fa fa-key" />
          </InputGroupText>
          <Input
            type={showCFPassword === true ? "text" : "password"}
            placeholder={i18next.t("Confirm Password")}
            autoComplete="on"
            value={cfpassword}
            onChange={ev => {
              setCFPassword(ev.currentTarget.value)
            }}
          />
          <InputGroupText
            onClick={() => {
              setShowCFPassword(!showCFPassword)
            }}
          >
            <MyIcon
              data={
                showCFPassword ? "type:HiOutlineEye" : "type:HiOutlineEyeOff"
              }
            />
          </InputGroupText>
        </InputGroup>
        {error && (
          <ErrorMessage className="mb-3 text-danger text-xl-center">
            {error}
          </ErrorMessage>
        )}
        <Button type="submit" color="primary" style={{ width: "100%" }}>
          {i18next.t("Reset Password")}
        </Button>
      </Form>
    </Container>
  )
}

export default connector(Login)
